

import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataTreatmentSummary extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name:CurrentLang().analytics_time_period, value: StringUtils.formatStringOrNoData(data.DateRange === undefined ? '' : CurrentLang()[`filter_option_${data.DateRange.toLowerCase()}`], CurrentLang().no_data) },
            { name: CurrentLang().analytics_number_of_organisations, value: StringUtils.formatStringOrNoData(data.OrganisationCount, CurrentLang().no_data)  },
            { name: CurrentLang().analytics_number_of_clinics, value: StringUtils.formatStringOrNoData(data.ClinicCount, CurrentLang().no_data) },
            { name: CurrentLang().analytics_number_of_devices, value: StringUtils.formatStringOrNoData(data.DeviceCount, CurrentLang().no_data) },
            { name: CurrentLang().analytics_number_of_treatments, value: StringUtils.formatStringOrNoData(data.TreatmentCount, CurrentLang().no_data) },
        ]

        return tableData;
    }
}




export default MagstimTableDataTreatmentSummary;
